import DatePeriod from './DatePeriod.container';

export default DatePeriod;
